import { BookingRequest, Flight } from '../types';

// Simulated delay for API call
const simulateDelay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// Mock booking confirmation
export const bookFlight = async (booking: BookingRequest): Promise<{
  success: boolean;
  confirmationId: string;
  message: string;
}> => {
  // Simulate network delay
  await simulateDelay(2000);

  // Generate a random confirmation ID
  const confirmationId = `ASTRA-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).substr(2, 6).toUpperCase()}`;

  // Simulate success (in real app, this would be actual API)
  return {
    success: true,
    confirmationId,
    message: `Booking confirmed for ${booking.passengers.length} passenger(s) to ${booking.flight?.destination}.`,
  };
};

// Sample flight data
export const mockFlights: Flight[] = [
  {
    id: 'ISS-001',
    destination: 'International Space Station',
    departure: '2026-06-15',
    returnDate: '2026-06-22',
    price: 4500000,
    class: 'first-class',
    duration: '6 hours',
    availableSeats: 4,
    description: '7-day orbital stay. Includes microgravity training and Earth observation deck access.',
    icon: '🛰️',
  },
  {
    id: 'GATEWAY-002',
    destination: 'Lunar Gateway',
    departure: '2026-08-01',
    returnDate: '2026-09-15',
    price: 7800000,
    class: 'zero-gravity',
    duration: '3 days transit',
    availableSeats: 2,
    description: '45-day lunar orbit experience. Moon surface excursions available (add-on).',
    icon: '🌙',
  },
  {
    id: 'ORBITAL-003',
    destination: 'Orbital Hotel Aurora',
    departure: '2026-07-20',
    returnDate: '2026-07-27',
    price: 3200000,
    class: 'premium',
    duration: '4 hours',
    availableSeats: 12,
    description: 'Luxury orbital hotel. Zero-g recreation, space walk packages, gourmet astronaut cuisine.',
    icon: '🏨',
  },
  {
    id: 'CIRCUM-004',
    destination: 'Circumlunar Flyby',
    departure: '2026-10-10',
    returnDate: '2026-10-17',
    price: 5500000,
    class: 'premium',
    duration: '5 days',
    availableSeats: 6,
    description: 'Loop around the Moon and return. No orbital capture. Best value for lunar view.',
    icon: '🌍',
  },
  {
    id: 'STATION-005',
    destination: 'Axiom Station',
    departure: '2027-01-15',
    returnDate: '2027-01-22',
    price: 3800000,
    class: 'economy',
    duration: '8 hours',
    availableSeats: 8,
    description: 'Commercial space station module. Laboratory tours, STEM workshops included.',
    icon: '🔬',
  },
  {
    id: 'HOTEL-006',
    destination: 'Orbital Hotel Voyager',
    departure: '2027-03-01',
    returnDate: '2027-03-10',
    price: 8900000,
    class: 'first-class',
    duration: '5 hours',
    availableSeats: 3,
    description: 'Ultra-luxury 9-day stay. Private cabin, personal attendant, photography suite.',
    icon: '✨',
  },
];
